import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, CheckIcon, MailIcon } from 'lucide-react';
import { ProjectCarousel } from '../components/ProjectCarousel';
export function Architecture() {
  return <div className="w-full min-h-screen bg-stone-50" data-id="element-440">
      {/* Header */}
      <header className="py-4 px-6 bg-white border-b border-stone-200" data-id="element-441">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-442">
          <Link to="/" className="inline-flex items-center gap-2 text-stone-600 hover:text-stone-900 transition-colors" data-id="element-443">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-444" />
            <span className="font-light" data-id="element-445">Back to Home</span>
          </Link>
          <h1 className="text-2xl font-light text-stone-900" data-id="element-446">Maria Elina</h1>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-10 px-6 bg-gradient-to-br from-stone-50 via-emerald-50/30 to-stone-50" data-id="element-447">
        <div className="max-w-7xl mx-auto text-center" data-id="element-448">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-449">
            <h2 className="text-5xl md:text-7xl font-light text-stone-900 mb-4 flex flex-col items-center gap-2" data-id="element-450">
              <img src="https://storage.yandexcloud.net/maria-images/images/Architecture.svg" alt="Architecture" className="md:w-16 md:h-16 w-10 h-10" data-id="element-451" />
              Architecture Concept
            </h2>
            <p className="text-xl text-stone-600 font-light max-w-2xl mx-auto" data-id="element-452">
              Spatial design and planning that harmonizes form, function,
              heritage and innovation
            </p>
          </motion.div>
        </div>
      </section>

      {/* Service Packages Section */}
      <section className="py-20 px-6 pt-[40px]" data-id="element-453">
        <div className="max-w-7xl mx-auto" data-id="element-454">
          {/* Section Header */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-center mb-16" data-id="element-455">
            <div className="relative inline-block" data-id="element-456">
              <h3 className="text-4xl md:text-5xl font-extralight text-stone-900 mb-6 tracking-tight" data-id="element-457">
                Service Packages
              </h3>
              <motion.div initial={{
              scaleX: 0
            }} whileInView={{
              scaleX: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8,
              delay: 0.2
            }} className="absolute -bottom-2 left-0 right-0 h-[2px] bg-emerald-600" style={{
              clipPath: 'polygon(10% 0, 90% 0, 100% 100%, 0 100%)'
            }} data-id="element-458" />
            </div>
          </motion.div>

          {/* Full Package - Featured */}
          <motion.div initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} whileHover={{
          y: -8
        }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 mb-8" style={{
          clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
        }} data-id="element-459">
            {/* Holographic gradient background */}
            <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/15 via-teal-400/15 to-cyan-400/15" data-id="element-460" />
            <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-461" />

            {/* Featured badge */}
            <div className="absolute top-3 right-3 md:top-6 md:right-6" data-id="element-462">
              <span className="inline-block px-2.5 py-1 text-xs md:px-4 md:py-1.5 md:text-sm font-light text-emerald-700 bg-emerald-100 rounded-full border border-emerald-200" data-id="element-463">
                Complete Solution
              </span>
            </div>

            <div className="relative z-10 p-10" data-id="element-464">
              <h4 className="text-3xl font-light text-stone-900 mb-8 tracking-tight" data-id="element-465">
                Full Package
              </h4>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-466">
                {/* Column 1 */}
                <div data-id="element-467">
                  <h5 className="text-lg font-medium text-emerald-700 mb-4 tracking-wide" data-id="element-468">
                    Concept Development
                  </h5>
                  <ul className="space-y-3" data-id="element-469">
                    <li className="flex items-start gap-3" data-id="element-470">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-471" />
                      <span className="text-stone-700 font-light" data-id="element-472">
                        Site analysis & context study
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-473">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-474" />
                      <span className="text-stone-700 font-light" data-id="element-475">
                        Spatial programming
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-476">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-477" />
                      <span className="text-stone-700 font-light" data-id="element-478">
                        Concept development & sketches
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-479">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-480" />
                      <span className="text-stone-700 font-light" data-id="element-481">
                        User experience detailing
                      </span>
                    </li>
                  </ul>
                </div>

                {/* Column 2 */}
                <div data-id="element-482">
                  <h5 className="text-lg font-medium text-emerald-700 mb-4 tracking-wide" data-id="element-483">
                    Technical Development
                  </h5>
                  <ul className="space-y-3" data-id="element-484">
                    <li className="flex items-start gap-3" data-id="element-485">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-486" />
                      <span className="text-stone-700 font-light" data-id="element-487">
                        Planning drawings & layouts
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-488">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-489" />
                      <span className="text-stone-700 font-light" data-id="element-490">
                        Material specification
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-491">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-492" />
                      <span className="text-stone-700 font-light" data-id="element-493">
                        Sustainability considerations
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-494">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-495" />
                      <span className="text-stone-700 font-light" data-id="element-496">
                        Presentation package
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Enquire Button */}
              <div className="mt-10" data-id="element-497">
                <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20Full%20Package%20%E2%80%93%20Architecture%20Concept&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20Full%20Package%20for%20Architecture%20Concept%2C%20which%20includes%3A%0D%0A%0D%0AConcept%20Development%3A%0D%0A%E2%80%A2%20Site%20analysis%20%26%20context%20study%0D%0A%E2%80%A2%20Spatial%20programming%0D%0A%E2%80%A2%20Concept%20design%20%26%20sketches%0D%0A%E2%80%A2%203D%20visualization%20%26%20renders%0D%0A%0D%0ATechnical%20Development%3A%0D%0A%E2%80%A2%20Planning%20drawings%20%26%20layouts%0D%0A%E2%80%A2%20Material%20specification%0D%0A%E2%80%A2%20Sustainability%20considerations%0D%0A%E2%80%A2%20Presentation%20package%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                y: -3
              }} className="group/btn inline-block relative" data-id="element-498">
                  <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                  clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                }} data-id="element-499" />
                  <div className="relative px-6 py-2 bg-emerald-600 text-white overflow-hidden mx-3 my-1.5" style={{
                  clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                }} data-id="element-500">
                    <div className="absolute inset-0 bg-emerald-700 translate-y-[100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-501" />
                    <span className="text-lg font-light relative z-10 inline-flex items-center gap-2" data-id="element-502">
                      <MailIcon className="w-4 h-4" data-id="element-503" />
                      Enquire
                    </span>
                  </div>
                </motion.a>
              </div>
            </div>

            {/* Angular corner accents */}
            <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-504" />
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-505" />
          </motion.div>

          {/* Other Packages Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-506">
            {/* Concept Design */}
            <motion.div initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} whileHover={{
            y: -8
          }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 h-full" style={{
            clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
          }} data-id="element-507">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/10 via-teal-400/10 to-cyan-400/10" data-id="element-508" />
              <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-509" />

              <div className="relative z-10 p-8 h-full flex flex-col" data-id="element-510">
                <h4 className="text-2xl font-light text-stone-900 mb-6 tracking-tight" data-id="element-511">
                  Concept Design
                </h4>
                <ul className="space-y-3 flex-grow" data-id="element-512">
                  <li className="flex items-start gap-3" data-id="element-513">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-514" />
                    <span className="text-stone-700 font-light" data-id="element-515">
                      Site analysis
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-516">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-517" />
                    <span className="text-stone-700 font-light" data-id="element-518">
                      Spatial programming
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-519">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-520" />
                    <span className="text-stone-700 font-light" data-id="element-521">
                      Concept sketches
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-522">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-523" />
                    <span className="text-stone-700 font-light" data-id="element-524">
                      Experience detailing
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-525">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-526" />
                    <span className="text-stone-700 font-light" data-id="element-527">
                      Client presentation package
                    </span>
                  </li>
                </ul>

                {/* Enquire Button */}
                <div className="mt-6" data-id="element-528">
                  <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20Concept%20Design&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20Concept%20Design%20package%2C%20which%20includes%3A%0D%0A%E2%80%A2%20Site%20analysis%0D%0A%E2%80%A2%20Spatial%20programming%0D%0A%E2%80%A2%20Concept%20sketches%0D%0A%E2%80%A2%203D%20visualization%0D%0A%E2%80%A2%20Client%20presentation%20package%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                  y: -2
                }} className="group/btn inline-block relative" data-id="element-529">
                    <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                    clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                  }} data-id="element-530" />
                    <div className="relative px-5 py-1.5 bg-transparent overflow-hidden mx-3 my-1.5" style={{
                    clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                  }} data-id="element-531">
                      <div className="absolute inset-0 bg-emerald-600 translate-y-[-100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-532" />
                      <span className="text-base font-light relative z-10 inline-flex items-center gap-2 text-emerald-600 group-hover/btn:text-white transition-colors duration-300" data-id="element-533">
                        <MailIcon className="w-4 h-4" data-id="element-534" />
                        Enquire
                      </span>
                    </div>
                  </motion.a>
                </div>
              </div>

              <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-535" />
              <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-536" />
            </motion.div>

            {/* Interior Planning */}
            <motion.div initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} whileHover={{
            y: -8
          }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 h-full" style={{
            clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
          }} data-id="element-537">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/10 via-teal-400/10 to-cyan-400/10" data-id="element-538" />
              <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-539" />

              <div className="relative z-10 p-8 h-full flex flex-col" data-id="element-540">
                <h4 className="text-2xl font-light text-stone-900 mb-6 tracking-tight" data-id="element-541">
                  Interior Planning
                </h4>
                <ul className="space-y-3 flex-grow" data-id="element-542">
                  <li className="flex items-start gap-3" data-id="element-543">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-544" />
                    <span className="text-stone-700 font-light" data-id="element-545">
                      Space planning & layout
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-546">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-547" />
                    <span className="text-stone-700 font-light" data-id="element-548">
                      Material moodboard
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-549">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-550" />
                    <span className="text-stone-700 font-light" data-id="element-551">
                      Furniture suggestions
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-552">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-553" />
                    <span className="text-stone-700 font-light" data-id="element-554">
                      Lighting design concept
                    </span>
                  </li>
                </ul>

                {/* Enquire Button */}
                <div className="mt-6" data-id="element-555">
                  <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20Interior%20Planning&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20Interior%20Planning%20package%2C%20which%20includes%3A%0D%0A%E2%80%A2%20Space%20planning%20%26%20layout%0D%0A%E2%80%A2%20Material%20%26%20finish%20selection%0D%0A%E2%80%A2%20Furniture%20specification%0D%0A%E2%80%A2%20Lighting%20design%20concept%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                  y: -2
                }} className="group/btn inline-block relative" data-id="element-556">
                    <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                    clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                  }} data-id="element-557" />
                    <div className="relative px-5 py-1.5 bg-transparent overflow-hidden mx-3 my-1.5" style={{
                    clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                  }} data-id="element-558">
                      <div className="absolute inset-0 bg-emerald-600 translate-y-[-100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-559" />
                      <span className="text-base font-light relative z-10 inline-flex items-center gap-2 text-emerald-600 group-hover/btn:text-white transition-colors duration-300" data-id="element-560">
                        <MailIcon className="w-4 h-4" data-id="element-561" />
                        Enquire
                      </span>
                    </div>
                  </motion.a>
                </div>
              </div>

              <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-562" />
              <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-563" />
            </motion.div>

            {/* Consultation */}
            <motion.div initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} whileHover={{
            y: -8
          }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 h-full" style={{
            clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
          }} data-id="element-564">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/10 via-teal-400/10 to-cyan-400/10" data-id="element-565" />
              <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-566" />

              <div className="relative z-10 p-8 h-full flex flex-col" data-id="element-567">
                <h4 className="text-2xl font-light text-stone-900 mb-6 tracking-tight" data-id="element-568">
                  Consultation
                </h4>
                <ul className="space-y-3 flex-grow" data-id="element-569">
                  <li className="flex items-start gap-3" data-id="element-570">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-571" />
                    <span className="text-stone-700 font-light" data-id="element-572">
                      Site assessment
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-573">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-574" />
                    <span className="text-stone-700 font-light" data-id="element-575">
                      Feasibility study
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-576">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-577" />
                    <span className="text-stone-700 font-light" data-id="element-578">
                      Design brief development
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-579">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-580" />
                    <span className="text-stone-700 font-light" data-id="element-581">
                      Preliminary concept sketches
                    </span>
                  </li>
                </ul>
                <p className="text-sm text-stone-500 font-light mt-4 italic" data-id="element-582">
                  *Ideal for early-stage projects
                </p>

                {/* Enquire Button */}
                <div className="mt-6" data-id="element-583">
                  <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20Consultation%20(Architecture)&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20Consultation%20package%20for%20Architecture%2C%20which%20includes%3A%0D%0A%E2%80%A2%20Site%20assessment%0D%0A%E2%80%A2%20Feasibility%20study%0D%0A%E2%80%A2%20Design%20brief%20development%0D%0A%E2%80%A2%20Preliminary%20concept%20sketches%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                  y: -2
                }} className="group/btn inline-block relative" data-id="element-584">
                    <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                    clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                  }} data-id="element-585" />
                    <div className="relative px-5 py-1.5 bg-transparent overflow-hidden mx-3 my-1.5" style={{
                    clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                  }} data-id="element-586">
                      <div className="absolute inset-0 bg-emerald-600 translate-y-[-100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-587" />
                      <span className="text-base font-light relative z-10 inline-flex items-center gap-2 text-emerald-600 group-hover/btn:text-white transition-colors duration-300" data-id="element-588">
                        <MailIcon className="w-4 h-4" data-id="element-589" />
                        Enquire
                      </span>
                    </div>
                  </motion.a>
                </div>
              </div>

              <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-590" />
              <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-591" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Work Samples Section */}
      <section className="py-24 px-6 bg-white border-t border-stone-100" data-id="element-592">
        <div className="max-w-7xl mx-auto" data-id="element-593">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-center mb-20" data-id="element-594">
            <h3 className="text-4xl md:text-5xl font-extralight text-stone-900 mb-6 tracking-tight" data-id="element-595">
              Work Samples
            </h3>
            <div className="w-24 h-[1px] bg-emerald-600 mx-auto" data-id="element-596" />
          </motion.div>

          {/* Project 1: Mariinsky Theatre-3 */}
          <div className="mb-32" data-id="element-597">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="text-center mb-12" data-id="element-598">
              <h4 className="text-3xl md:text-4xl font-light text-stone-900 mb-3" data-id="element-599">
                Mariinsky Theatre-3
              </h4>
              <p className="text-emerald-700 font-medium mb-6 tracking-wide uppercase text-sm" data-id="element-600">
                Interior Planning & Adaptive Re-Use
              </p>
              <p className="text-lg text-stone-600 font-light max-w-3xl mx-auto leading-relaxed" data-id="element-601">
                Transforming St. Petersburg's historic Main Post Office into a
                world-class concert venue for the Mariinsky Theatre.
              </p>
            </motion.div>

            <ProjectCarousel slides={[{
            image: 'https://storage.yandexcloud.net/maria-images/images/Visualizations%20mar%202.png',
            caption: 'Concept Visualizations'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/Ideation%20mar.png',
            caption: 'Concept Development'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/Courtyard%20Study.png',
            caption: 'Facility Studies'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/Seating%20arrangements.png',
            caption: 'Auditorium Planning'
          }]} data-id="element-602" />
          </div>

          {/* Project 2: Transformer Theatre */}
          <div data-id="element-603">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="text-center mb-12" data-id="element-604">
              <h4 className="text-3xl md:text-4xl font-light text-stone-900 mb-3" data-id="element-605">
                Transformer Theatre
              </h4>
              <p className="text-emerald-700 font-medium mb-6 tracking-wide uppercase text-sm" data-id="element-606">
                Interior Architecture & Adaptive Re-Use
              </p>
              <p className="text-lg text-stone-600 font-light max-w-3xl mx-auto leading-relaxed" data-id="element-607">
                A renovation proposition for an abandoned Art Deco building in
                Bournemouth, transforming it into a versatile cultural venue.
              </p>
            </motion.div>

            <ProjectCarousel slides={[{
            image: 'https://storage.yandexcloud.net/maria-images/images/Visualization%20aub.png',
            caption: 'Concept Visualizations'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/3d%20concept%20aub.png',
            caption: '3D Visualizations'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/Building%20studies.png',
            caption: 'Building Studies'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/Day%20programming.png',
            caption: 'User Experience Programming'
          }]} data-id="element-608" />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-t from-emerald-50/40 via-stone-50 to-stone-50 border-t border-emerald-600/30" data-id="element-609">
        <div className="max-w-4xl mx-auto text-center" data-id="element-610">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-611">
            <h2 className="text-4xl md:text-5xl font-light mb-6 text-stone-900" data-id="element-612">
              Have a specific request?
            </h2>
            <p className="text-xl text-stone-600 font-light mb-8" data-id="element-613">
              Let's discuss what we can create together
            </p>
            <motion.a href="mailto:contact@maria-elina.com" whileHover={{
            y: -3
          }} className="group inline-block relative" data-id="element-614">
              {/* Outer border layer */}
              <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
              clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
            }} data-id="element-615" />
              {/* Inner filled layer */}
              <div className="relative px-6 py-2 bg-emerald-600 text-white overflow-hidden mx-3 my-1.5" style={{
              clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
            }} data-id="element-616">
                <div className="absolute inset-0 bg-emerald-700 translate-y-[100%] group-hover:translate-y-0 transition-transform duration-300" data-id="element-617" />
                <span className="text-lg font-light relative z-10 inline-flex items-center gap-2" data-id="element-618">
                  <MailIcon className="w-4 h-4" data-id="element-619" />
                  Get in Touch
                </span>
              </div>
            </motion.a>
          </motion.div>
        </div>
      </section>
    </div>;
}